<template>
  <b-form inline class="mb-3">
    <label>{{ trans('communication_type') }}:</label>
    <b-form-radio v-model="comtype" value="marketing" class="ml-2" :disabled="disabled">
      {{ trans('communication_type_marketing') }}
      <small class="text-muted" :title="trans('communication_type_marketing_about')" v-b-tooltip.hover>
        <i class="fa fa-fw fa-info-circle"></i>
      </small>
    </b-form-radio>
    <b-form-radio v-model="comtype" value="reminders" class="ml-2" :disabled="disabled">
      {{ trans('communication_type_reminders') }}
      <small class="text-muted" :title="trans('communication_type_reminders_about')" v-b-tooltip.hover>
        <i class="fa fa-fw fa-info-circle"></i>
      </small>
    </b-form-radio>
  </b-form>
</template>

<script>
  export default {
    props: {
      value: String,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        comtype: this.value,
      }
    },
    watch: {
      value() {
        if (this.comtype != this.value)
          this.comtype = this.value
      },
      comtype() {
        this.$emit('input', this.comtype)
      },
    },
    mounted() {
      window.comtypeComponent = this
    },
  }
</script>